<template>
  <div class='payment'>
    <!-- <Header title="付款申请单申请"></Header> -->
    <mu-container>
      <mu-card style="width: 100%;  margin: 0 auto;padding:5px;">
      <van-form @submit="payment_submit">
        <van-cell-group title="基本信息" :border="true" size="large">
          <van-field v-model="paymentForm.no" label="申请编号" size='large' :border="true"  readonly />
          <van-field v-model="paymentForm.title" label="标题" size='large'  required :border="true" placeholder="请输入标题" />
          <van-field v-model="paymentForm.desc" label="费用说明"  required rows="5" type="textarea" size='large' :border="true" placeholder="请输入费用说明" :rules="[{ required: true, message: '请输入费用说明' }]"/>
          <van-field v-model="paymentForm.ps" label="附言"   size='large' :border="true" placeholder="请输入附言内容,附言内容不打印" />
          <!-- <van-field v-model="paymentForm.contract_no" label="合同编号" size='large' :border="true" placeholder="请输入合同编号" />
          <van-field v-model="paymentForm.contract_url" label="合同链接" size='large' :border="true" placeholder="请输入合同链接" /> -->
        </van-cell-group>
        <van-cell-group title="申请人信息" :border="true">
          <van-field v-model="paymentForm.user_name" label="姓名"  required size='large' :border="true" readonly />
          <van-field v-model="paymentForm.department" label="部门"  required size='large' placeholder="请选择所在部门" @click="department.show = true" :rules="[{ required: true, message: '请选择所在部门' }]" readonly is-link/>
          <van-action-sheet v-model="department.show" :actions="department.options" @select="department_onselect" />
          <van-field v-model="paymentForm.position" label="职位"  required size='large' :border="true" readonly />
          <!-- <van-field v-model="paymentForm.is_self" readonly center label="是否本人报销" size='large' :border="true" is-link @click="is_self.show = true"  :rules="[{ required: true, message: '请选择是否本人报销' }]"/>
          <van-action-sheet v-model="is_self.show" :actions="is_self.options" @select="is_self_onselect" /> -->
          
        </van-cell-group>
        <PayInfo @change_pay_info="change_pay_info" :payInfo='payInfos'></PayInfo>
        

        <Cost :costs="costs" :fileList="files" :files="paymentForm.filelist" :cost_centers='cost_centers' :cost_accounts='cost_accounts' @changeCost="changeCost"></Cost>
        <Approver :approvers='paymentForm.approvers'></Approver>
        <CopyTo :copytos='paymentForm.copytos'></CopyTo>
          
        
        
          
      
        <div style="margin: 20px 0 50px 0;">
          <van-row>
            <!-- <van-col span="12"><van-button type="primary" native-type="submit">保存草稿</van-button></van-col> -->
            <van-col span="24"><van-button :loading="is_loading" loading-text="提交中..."  type="info" native-type="submit" >提交审批</van-button></van-col>
          </van-row>
          
          
        </div>
      </van-form>
    </mu-card>
    </mu-container>
  </div>
</template>

<script>
import Header from '../../components/Header.vue'
import Approver from '../../components/Payment/Approver.vue'
import CopyTo from '../../components/Payment/CopyTo.vue'
import Cost from '../../components/Payment/Cost.vue'
import PayInfo from '../../components/Payment/PayInfo.vue'

export default {
  components: { Header,Approver,Cost, PayInfo,CopyTo},
  name: 'Administrative',
  props: {
    
  },
  data(){
    return{
      is_repeat:0,
      is_loading:false,
      cost_centers:{},
      cost_account:{},
      user:{},
      department:{
        show:false,
        options:{},
      },
      is_self:{
        show:false,
        // options:['银行转账','现金','支票','承兑汇票'],
        options:[
          {name:'是'},
          {name:'否'},
        ]
      },
      flow_id:this.$route.query.from_flow_id,
      payInfos:{
        payer:'',
        payer_id:'',
        payee:'',
        bank:'',
        bank_account:'',
        payment_term:'银行转账',

      },
      costs:[
        {
          cost_center:'',
          center_id:'',
          cost_account:'',
          account_id:'',
          amount:'',
          budget_id:'',
          budget:'',
          budget_used:'',
          budget_applying:'',
          budget_usable:'',
        }
      ],
      
      
      paymentForm:{
        no:'',
        // is_group:this.$route.query.is_group,
        classify:this.$route.query.classify,
        catalog_id:14,
        userid:'',
        is_self:'',
        title:'',
        desc:'',
        ps:'',
        contract_no:'',
        contract_url:'',
        user_name:'',
        department:'',
        department_id:'',
        position:'',
        payer:'',
        payer_id:'',
        payee:'',
        bank:'',
        bank_account:'',
        amount:'',
        amount_word:'',
        payment_term:'',
        costs:[
          {
            cost_center:'',
            center_id:'',
            cost_account:'',
            account_id:'',
            amount:'',
            budget_id:'',
            budget:'',
            budget_used:'',
            budget_applying:'',
            budget_usable:'',
          }
        ],
        approvers:[],
        copytos:[],
        filelist:[],
      },
      files:[],
      approverForm:{
        classify:'',
        department_id:'',
        amount:0,
        costs:[],


      },
      

    }
  },
  created(){
    document.title = '税金支付申请'
    // this.getCostCenter()
    // this.getCostAccount()
    // this.getUserInfo();
    this.getBaseInfo();
  },
  methods:{
    getFlow(){
      this.$http.get('/flow/'+this.flow_id)
      .then((res)=>{
        console.log(res)
        this.paymentForm.title = res.data.data.title;
        this.paymentForm.desc = res.data.data.desc;
        this.paymentForm.ps = res.data.data.ps;
        this.payInfos.payer = res.data.data.payer;
        this.payInfos.payer_id = res.data.data.payer_id;
        this.paymentForm.payer_id = res.data.data.payer_id;
        this.payInfos.payee = res.data.data.payee;
        this.payInfos.bank = res.data.data.bank;
        this.payInfos.bank_account = res.data.data.bank_account;
        this.payInfos.payment_term = res.data.data.payment_term;
        this.paymentForm.filelist = res.data.data.filelist;
        // this.paymentForm.department_id = res.data.data.department_id;
        // this.approverForm.department_id = res.data.data.department_id;
        this.files = res.data.data.files;
        this.costs = res.data.data.costs;
        this.getApprover();

      })
    },
    getBaseInfo(){
      this.$http.post('flow/base_info',this.paymentForm)
      .then((res)=>{
        console.log(res)
        if(res.data.code == 204){
          this.$router.push({'name':'Login'})
          return false;

        }
        if(res.data.code !=200){
          console.log(res.data.msg)
        }
        this.cost_centers = res.data.data.cost_centers;
        this.cost_accounts = res.data.data.cost_accounts;
        this.user = res.data.data.user_info
        this.paymentForm.no = res.data.data.flow_no;
        this.paymentForm.position = this.user.position
        this.paymentForm.user_name = this.user.name
        this.paymentForm.userid = this.user.userid
        this.department.options = this.user.departments
        this.payInfos.payee = res.data.data.user_account.name;
        this.payInfos.bank = res.data.data.user_account.bank;
        this.payInfos.bank_account = res.data.data.user_account.bank_account;
        this.paymentForm.title = this.user.name+'提交的税金支付申请'
        if(this.user.departments.length == 1){
          this.paymentForm.department = this.user.departments[0].name;
          this.paymentForm.department_id = this.user.departments[0].Id;
          this.approverForm.department_id = this.user.departments[0].Id
          this.getApprover();

        }
        if(this.flow_id){
          this.getFlow();
        }

      })

    },
    getUserInfo(){
      this.$http.post('user_info',{userid:this.userid})
      .then((res)=>{
        console.log(res.data.code)
        if(res.data.code !=200){
          console.log(res.data.msg)
        }
        this.user = res.data.data
        this.paymentForm.position = this.user.position
        this.paymentForm.user_name = this.user.name
        this.paymentForm.userid = this.user.userid
        this.department.options = this.user.departments
        
      })

    },
    getCostCenter(){
      this.$http.post('getcostcenter')
      .then((res)=>{
        console.log(res)
        if(res.data.code !=200){
          console.log(res.data.msg)
        }
        this.cost_centers = res.data.data;
      })

    },
    getCostAccount(){
      this.$http.post('getcostaccount')
      .then((res)=>{
        console.log(res)
        if(res.data.code !=200){
          console.log(res.data.msg)
          return false;
        }
        this.cost_accounts = res.data.data;
      })
    },
    //获取审批人
    getApprover(){
      if(!this.approverForm.department_id){
        return false;
      }
      this.approverForm.classify= this.paymentForm.classify;
      this.approverForm.amount= this.paymentForm.amount;
      this.approverForm.payer_id = this.paymentForm.payer_id
      this.$http.post('tax/approver',this.approverForm)
      .then((res)=>{
        console.log(res)
        this.paymentForm.approvers = res.data.data.approvers;
        this.paymentForm.copytos = res.data.data.copytos;
        console.log(this.paymentForm.approvers)
      })
      

    },
    
    
    department_onselect(item){
      this.department.show = false;
      this.paymentForm.department = item.name;
      this.paymentForm.department_id = item.Id;
      // this.payment.department = item.name;
      this.approverForm.department_id = item.Id;
      this.getApprover();

    },
    is_self_onselect(item){
      this.paymentForm.is_self = item.name
      this.is_self.show = false;
    },
    
    payment_submit(){
      if(this.is_repeat ==1){
        this.$dialog.alert({
          message: '重复提交，请稍等。',
        })
        return false;
      }
      this.is_repeat = 1
      this.is_loading = true
      this.$http.put('tax',this.paymentForm)
      .then((res)=>{
        if(res.data.code !=200){
          this.$dialog.alert({
            message: res.data.msg,
          })
          this.is_loading = false;
          this.is_repeat = 0
          return false;

        }
        this.$dialog.alert({
          message: res.data.msg,
        }).then(() => {
          this.$router.push({'name':'MyFlow'})
        });
      })
    },
    change_pay_info(payinfo){
      // console.log(payinfo)
      this.paymentForm.payer = payinfo.payer
      this.paymentForm.payee = payinfo.payee
      this.paymentForm.bank = payinfo.bank
      this.paymentForm.bank_account = payinfo.bank_account
      // this.paymentForm.amount = payinfo.amount
      // this.paymentForm.amount_word = payinfo.amount_word
      this.paymentForm.payment_term = payinfo.payment_term
      this.paymentForm.payer_id = payinfo.payer_id;
      this.getApprover();
    },

    changeCost(costs,amount,amount_word,files){
      // console.log(costs)
      this.paymentForm.costs = costs;
      this.approverForm.costs = costs;
      this.paymentForm.amount = amount;
      this.paymentForm.amount_word = amount_word;
      this.paymentForm.filelist = files;
      this.getApprover();
    },
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.payment{
  background-color: #eee;
}
.van-cell-group__title{
  background-color:#3f51b5 ;
  font-size:14px;
  font-weight:blod;
  color:white;
  padding:13px;

}
.title-style{
  font-size:26px;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>
